import { HttpClient }  from '@angular/common/http';
import {
  Inject,
  Injectable,
}                      from '@angular/core';
import { Observable }  from 'rxjs';
import {
  AccountUser,
  UserSettings,
}                      from '~domain/types';
import { ENVIRONMENT } from '../app.constants';

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  constructor(
    @Inject(ENVIRONMENT)
    private readonly environment: Environment,
    private readonly http: HttpClient,
  ) {
  }

  fetchAccountUser(): Observable<AccountUser> {
    return this.http.get<AccountUser>(`${this.environment.api}/profile`);
  }

  updateAuth0UserId(id: string): Observable<void> {
    return this.http.put<void>(`${this.environment.api}/auth0-user-id`, id);
  }

  fetchUserSettings(): Observable<UserSettings> {
    return this.http.get<UserSettings>(`${this.environment.api}/settings`);
  }

  setUserSettings(userSettings: UserSettings): Observable<UserSettings> {
    return this.http.put<UserSettings>(`${this.environment.api}/settings`, userSettings);
  }
}
